import { getUserInfo } from '@/main';
import graphql from '@/graphql';
import graphqlHelper from '@/services/graphqlHelper';
import { DEFAULT_OFFICE, DEFAULT_ROLE } from '@/constants';

const fetchUser = async (sessionExpired) => {
  const userInfo = await getUserInfo();
  return graphqlHelper(
    {
      query: graphql.user.queries.get,
      variables: {
        email: userInfo.email,
      },
    },
    sessionExpired
  );
};

const addUser = async () => {
  const userInfo = await getUserInfo();
  return graphqlHelper({
    query: graphql.user.mutations.add,
    variables: {
      name: userInfo.name,
      email: userInfo.email,
      office: DEFAULT_OFFICE,
      role: DEFAULT_ROLE,
    },
  });
};

const addUserDiet = ({ user, diet }) =>
  graphqlHelper({
    query: graphql.user.mutations.addUserDiet,
    variables: {
      user,
      diet,
    },
  });

const updateIsFirstLogged = async (value) => {
  const userInfo = await getUserInfo();
  return graphqlHelper({
    query: graphql.user.mutations.updateIsFirstLogged,
    variables: {
      email: userInfo.email,
      isFirstLogged: value,
    },
  });
};

const updateUserOffice = async (value) => {
  const userInfo = await getUserInfo();
  return graphqlHelper({
    query: graphql.user.mutations.updateUserOffice,
    variables: {
      email: userInfo.email,
      office: value,
    },
  });
};

const deleteUserDiet = ({ user, diet }) =>
  graphqlHelper({
    query: graphql.user.mutations.deleteUserDiet,
    variables: {
      user,
      diet,
    },
  });

const setUserAllergies = ({ user, allergies }) =>
  graphqlHelper({
    query: graphql.user.mutations.setUserAllergies,
    variables: {
      user,
      allergies,
    },
  });

const createUsers = (users) =>
  graphqlHelper({
    query: graphql.user.mutations.createUsers,
    variables: {
      users,
    },
  });

export {
  addUser,
  fetchUser,
  addUserDiet,
  updateIsFirstLogged,
  updateUserOffice,
  deleteUserDiet,
  setUserAllergies,
  createUsers,
};



// WEBPACK FOOTER //
// ./src/services/user.js